import { useParams, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import SeoHead, { SEO_KEYWORDS } from "../components/SeoHead";
import { useAuth } from "../context/AuthContext";

function SeoPage() {
  const { keyword } = useParams();
  const formatted = keyword.replace(/-/g, " ");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleGenerate = () => {
    const randomName = `${keyword}${Math.floor(Math.random() * 1000)}`;
    if (isAuthenticated) {
      navigate(`/dashboard?inbox=${randomName}`);
    } else {
      navigate("/signup", { state: { inbox: randomName } });
    }
  };

  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-6 py-12 text-center">
        <SeoHead
          title={`Temporary Inbox for ${formatted} – Ghost Inbox`}
          description={`Create a secure temporary inbox for ${formatted} sign-up and verification testing. Receive verification emails instantly with Ghost Inbox — privacy protection with auto-delete in 20 minutes.`}
          path={`/temp-email-for/${keyword}`}
          keywords={`temporary inbox for ${formatted}, email testing ${formatted}, verification testing, ${SEO_KEYWORDS}`}
        />

        <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl">
          Temporary Inbox for {formatted}
        </h1>

        <p className="mt-4 text-zinc-400">
          Sign up on Ghost Inbox to get a secure temporary address for {formatted} registration
          testing — protect your personal inbox and validate verification workflows.
        </p>

        <button
          type="button"
          onClick={handleGenerate}
          className="mt-6 rounded-lg bg-emerald-500 px-6 py-2.5 text-sm font-semibold text-zinc-950 hover:bg-emerald-400"
        >
          {isAuthenticated ? "Open Inbox Dashboard" : "Sign Up & Get Email"}
        </button>

        <h2 className="mt-10 text-2xl font-semibold text-white">
          Why use a temporary inbox for {formatted}?
        </h2>
        <p className="mt-3 text-zinc-400">
          Platforms like {formatted} often require email verification. A dedicated testing inbox
          receives OTPs and links instantly while keeping your personal email private.
        </p>

        <h2 className="mt-10 text-2xl font-semibold text-white">How Ghost Inbox Works</h2>
        <p className="mt-3 text-zinc-400">
          Create an account, pick a username, and use username@ghostinbox.xyz for {formatted}{" "}
          testing. Your dashboard refreshes every 10 seconds; messages expire after 20 minutes.
        </p>

        <ul className="mt-6 space-y-2 text-left text-zinc-400">
          <li>Instant address creation after login</li>
          <li>Secure account access</li>
          <li>Auto-delete after 20 minutes</li>
          <li>Real-time inbox updates</li>
          <li>Free to use</li>
        </ul>

        <button
          type="button"
          onClick={handleGenerate}
          className="mt-8 rounded-lg border border-zinc-600 px-6 py-2.5 text-sm text-white hover:border-zinc-400"
        >
          Get Started
        </button>
      </div>
    </Layout>
  );
}

export default SeoPage;
